import { createIcon } from '@chakra-ui/react';

export const DinersClub = createIcon({
  displayName: 'DinersClub',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none">
        <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#E4E4E7" />
        <path
          d="M19.045 19.4999C22.9425 19.5187 26.5 16.2921 26.5 12.367C26.5 8.07494 22.9425 5.10785 19.045 5.10945H15.6906C11.7467 5.10785 8.5 8.07574 8.5 12.367C8.5 16.2929 11.7467 19.5187 15.6906 19.4999H19.045Z"
          fill="#0079BE"
        />
        <path
          d="M15.7064 5.70423C12.1021 5.70543 9.18187 8.6533 9.18066 12.2917C9.18187 15.9296 12.1021 18.8775 15.7064 18.8787C19.3111 18.8775 22.2326 15.9296 22.233 12.2917C22.2326 8.6533 19.3115 5.70543 15.7064 5.70423ZM11.5702 12.2917C11.5694 11.4504 11.8225 10.6286 12.2962 9.93343C12.77 9.2383 13.4424 8.70225 14.2257 8.39536V16.1876C13.4424 15.8809 12.7698 15.345 12.2961 14.6499C11.8223 13.9548 11.5693 13.1329 11.5702 12.2917ZM17.1868 16.1892V8.39496C17.9706 8.70142 18.6436 9.23741 19.1177 9.93278C19.5918 10.6281 19.8449 11.4505 19.8438 12.2921C19.8447 13.1336 19.5916 13.9559 19.1175 14.6512C18.6434 15.3465 17.9705 15.8826 17.1868 16.1892Z"
          fill="white"
        />
        <path
          d="M19.045 19.4999C22.9425 19.5187 26.5 16.2921 26.5 12.367C26.5 8.07494 22.9425 5.10785 19.045 5.10945H15.6906C11.7467 5.10785 8.5 8.07574 8.5 12.367C8.5 16.2929 11.7467 19.5187 15.6906 19.4999H19.045Z"
          fill="#0079BE"
        />
        <path
          d="M15.7064 5.70423C12.1021 5.70543 9.18187 8.6533 9.18066 12.2917C9.18187 15.9296 12.1021 18.8775 15.7064 18.8787C19.3111 18.8775 22.2326 15.9296 22.233 12.2917C22.2326 8.6533 19.3115 5.70543 15.7064 5.70423ZM11.5702 12.2917C11.5694 11.4504 11.8225 10.6286 12.2962 9.93343C12.77 9.2383 13.4424 8.70225 14.2257 8.39536V16.1876C13.4424 15.8809 12.7698 15.345 12.2961 14.6499C11.8223 13.9548 11.5693 13.1329 11.5702 12.2917ZM17.1868 16.1892V8.39496C17.9706 8.70142 18.6436 9.23741 19.1177 9.93278C19.5918 10.6281 19.8449 11.4505 19.8438 12.2921C19.8447 13.1336 19.5916 13.9559 19.1175 14.6512C18.6434 15.3465 17.9705 15.8826 17.1868 16.1892Z"
          fill="white"
        />
      </svg>
    </>
  ),
});
